import React, { FC } from "react";

import { ACTIONS, LocationPicker } from "@adsk/acc-locations-components";
import { useLocale } from "@adsk/alloy-react-locale";

import i18n from "../i18n";
import { AssetDTO } from "../models";
import { ColumnFormField } from "./commonStyledComponents";

export const LOCATION_FILTER_EMPTY_VALUE = "NO_LOCATION";

type LocationFilterFilter = {
  locationId: AssetDTO["locationId"];
  includeSublocations: boolean;
  onSelectIncludeSublocations: (isSelected: boolean) => void;
  onSelectLocation: (locationId: AssetDTO["locationId"]) => void;
  onRemoveLocation: () => void;
};

const LocationFilter: FC<LocationFilterFilter> = ({
  includeSublocations,
  onSelectIncludeSublocations,
  locationId,
  onSelectLocation,
  onRemoveLocation,
}) => {
  const { T } = useLocale(i18n);

  return (
    <ColumnFormField label={T.translate("locationFilter.label")}>
      <LocationPicker
        clearable
        searchPlaceholder={T.translate("locationFilter.placeholder") as string}
        includeSubLocations={includeSublocations}
        selectedNodeId={locationId || LOCATION_FILTER_EMPTY_VALUE}
        onNodeSelect={(location) => {
          const locationId = Array.isArray(location)
            ? location[0].id
            : location?.id;
          if (locationId) {
            onSelectLocation(locationId);
          } else {
            onRemoveLocation();
          }
        }}
        action={ACTIONS.ASSIGN}
        onIncludeSubLocation={onSelectIncludeSublocations}
      />
    </ColumnFormField>
  );
};

export default LocationFilter;
